import React, { useState } from "react";
import SubHeader from "../../menu/SubHeader";
import { ISelectOption } from "../forms/util";
import { OperationalFormsSidebar } from "./OperationalFormsSidebar";
import './OperationalForms.css'
import { TrainEventRecordPageSelector } from "./TrainEventRecord/TrainEventRecordPageSelector";

interface OperationalFormsPageProps {
    selectedPage: ISelectOption,
    children?: React.ReactNode
}

export const OperationalFormsPage = (props: OperationalFormsPageProps) => {
    const [currentSelection] = useState(props.selectedPage);

    return (
        <>
            <div className="operational-forms">
                <div className="operational-forms-header-bg"></div>
                <div className="narrow-container">
                    <SubHeader />
                    <div className="operational-forms-page">
                        <TrainEventRecordPageSelector selectedPage={currentSelection} />

                        <div className="row">
                            <div className="de-wide col-3">
                                <OperationalFormsSidebar selectedPage={currentSelection} />
                            </div>
                            <div className="col">
                                <React.Fragment>{props.children}</React.Fragment>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};